'use client'

import { FC, useState } from 'react'

import { PaginatedReviewPublic } from '@/api'
import { PAGINATION_DEFAULT_PAGE, PAGINATION_DEFAULT_SIZE } from '@/constants/pagination'
import { Container } from '@/uikit/container'
import { Pagination } from '@/uikit/pagination'
import { ReviewCard } from '@/components/review-card'
import { getReviewList } from '@/modules/review'

import styles from './review-page.module.scss'

interface ReviewPageProps {
  reviews: PaginatedReviewPublic
}

export const ReviewPage: FC<ReviewPageProps> = ({ reviews }) => {
  const [reviewList, setReviewList] = useState(reviews)
  const [currentPage, setCurrentPage] = useState(PAGINATION_DEFAULT_PAGE)

  const onPageChange = async (page: number) => {
    const review = await getReviewList({
      page: page,
      size: PAGINATION_DEFAULT_SIZE,
    })
    setCurrentPage(page)
    setReviewList(review)
  }

  return (
    <Container>
      <div className={styles.root}>
        <div className={styles.list}>
          {reviewList.results.map((review) => (
            <div key={review.id}>
              <ReviewCard review={review} />
            </div>
          ))}
        </div>
        <div className={styles.pagination}>
          <Pagination
            currentPage={currentPage}
            totalCount={reviewList.count ?? 0}
            pageSize={PAGINATION_DEFAULT_SIZE}
            onPageChange={(page: number) => onPageChange(page)}
          />
        </div>
      </div>
    </Container>
  )
}
